import { render, staticRenderFns } from "./salesDialog.vue?vue&type=template&id=1528ad27&scoped=true&"
import script from "./salesDialog.vue?vue&type=script&lang=js&"
export * from "./salesDialog.vue?vue&type=script&lang=js&"
import style0 from "./salesDialog.vue?vue&type=style&index=0&id=1528ad27&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1528ad27",
  null
  
)

export default component.exports